export function useSafeStorage(key: string) {
  if (process.client) {
    const cookieRef = useCookie<string | null>(key, {
      sameSite: 'lax',
      secure: true,
      path: '/',
    });

    // Read value safely
    let value: string | null = null


    value = (localStorage.getItem(key) ?? cookieRef.value) ?? null

    if (value === 'null' || value === 'undefined') {
        return null
    }

    return value
  }
}